import { GESTION_OPERATIVA_GET_DESCUENTO } from './constants'

export function getDescuentoInfo(currentDataDiscounts, remainder) {
  return async (dispatch) => {   
    dispatch({
      type: GESTION_OPERATIVA_GET_DESCUENTO,
      data: {
        monto: currentDataDiscounts?.maxSpecialDiscount || 0,
        porcentaje: currentDataDiscounts?.tomausado || 0,
        remainder: remainder || 0
      },
    })
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_GET_DESCUENTO) {
      return {
        ...state,
        maximoDescuento: action.data
      }
  }
  else {
    return state
  }      
}
